import "./GridMatchEvents.css";

import {
  ISoccerMatchEventsWithCount,
  ISoccerMatchGoalEventWithCount,
  ISoccerPenaltyEvent,
  SoccerMatchEventType,
} from "../../../../../types";
import {
  GlobalCardEvent,
  GlobalGoalEvent,
  GlobalSubstituteEvent,
} from "../../GlobalMatchEvents";
import GridPenaltyEvent from "./GridPenaltyEvent";

export default function MatchEvents({
  event,
}: {
  event: ISoccerMatchEventsWithCount;
}) {
  switch (event.eventType) {
    case SoccerMatchEventType.GOAL:
      return (
        <GlobalGoalEvent
          event={event as ISoccerMatchGoalEventWithCount}
          iconSize={8}
          showCount={true}
          wrapperClassName="player-event goal-event"
        />
      );
    case SoccerMatchEventType.PENALTY:
      return <GridPenaltyEvent event={event as ISoccerPenaltyEvent} />;

    case SoccerMatchEventType.CARD:
      return (
        <GlobalCardEvent
          event={event as ISoccerMatchGoalEventWithCount}
          iconSize={8}
          wrapperClassName="player-event card-event"
        />
      );

    case SoccerMatchEventType.SUSTITUTE:
      return <GlobalSubstituteEvent />;

    default:
      return <></>;
  }
}
